import { useQuery } from "@tanstack/react-query";
import rateCardProvider from "@/providers/rate-card.provider";
import { rateCardKeys } from "./queryKeys";

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export function useGetRateCardQuery(rateCardId: string | undefined) {
  return useQuery({
    queryKey: rateCardId ? rateCardKeys.detail(rateCardId) : rateCardKeys.detail("__disabled__"),
    queryFn: () => rateCardProvider.getRateCard(rateCardId as string),
    enabled: !!rateCardId,
    staleTime: FIVE_MINUTES_MS,
  });
}
